import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Apply saved theme before first paint to avoid flash
try {
  const saved = localStorage.getItem("procureo-theme");
  if (saved && saved !== "gray") document.documentElement.setAttribute("data-theme", saved);
} catch { /* ignore */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
